<template>
  <v-container>
    <v-row>
      <v-col sm=4> 
         <common-design-card card_title="Documents pending for Route" :primary_text="documentForRoutesCount"/>
      </v-col>
      <v-col sm=4> 
         <common-design-card card_title="Routes In-Progress" :primary_text="routesInProgressCount"/>
      </v-col>
       <v-col sm=4> 
         <common-design-card card_title="Routes due in 1 day" :primary_text="routesDueIn1"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm=4> 
         <common-design-card card_title="Routes that are Overdue" :primary_text="overDueCount"/>
      </v-col>
      <v-col sm=4> 
         <common-design-card card_title="Routes that have been idled for 24 hours" :primary_text="idleRoutes"/>
      </v-col>
      <v-col sm=4> 
        <total-documents-card  category_label="Document Categories"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CommonDesignCard from "./cards/CommonDesignCard"
import TotalDocumentsCard from "./cards/TotalDocuments"
import { mapState, mapActions } from "vuex"

export default {
    components:{
        CommonDesignCard,
        TotalDocumentsCard
    },
    data:()=>({
      routesDueIn1:0,
      overDueCount:0,
      idleRoutes:0,
    }),
    computed: {
      ...mapActions([
        "fetchDocumentCategories"
      ]),
      ...mapState({
        documentForRoutesCount: (state) => state.dashboard.documentForRoutesCount,
        routesInProgressCount: (state) => state.dashboard.routesInProgressCount,
      }),
      routesDueInOneDay(){
        return  this.$store.dispatch('dashboard/fetchRouteThatAreDueIn',1)
      }
    },
    mounted:async function(){
      this.$store.dispatch('dashboard/fetchForRoutes')
      this.$store.dispatch('dashboard/fetchRouteInProgress')
      // this.$store.dispatch('dashboard/fetchDocumentByCategory')
      this.overDueCount = await this.$store.dispatch('dashboard/fetchOverDueRoutes')
      this.routesDueIn1 = await this.$store.dispatch('dashboard/fetchRouteThatAreDueIn',1)
      this.idleRoutes = await this.$store.dispatch('dashboard/fetchIdleRoutes')
      this.$store.dispatch('dashboard/fetchTopCategories',4)
    },
    created: function(){
      this.fetchDocumentCategories
    }
}
</script>
